import { http } from "./ky";
import type { Options } from "ky";

export type CreateUserRequest = {
  first_name?: string;
  last_name?: string;
  email?: string;
  password?: string;
  role: 0 | 1 | 2 | 3; // 0: admin | 1: manager | 2: translator | 3: customer
  picture?: string; // base64 string
  type?: string;
  source?: string;
};

export type CreateUserResponse = {
  user_id: number;
};

export const createUser = async (
  data: CreateUserRequest,
  config?: Options
): Promise<CreateUserResponse> => {
  const response = await http.post("user/create", {
    json: data,
    ...config,
  });

  return await response.json<CreateUserResponse>();
};

export type GetUserByEmailResponse = {
  user?: {
    created_at: string | null;
    deleted_at: string | null;
    description: string | null;
    email: string;
    first_name: string | null;
    last_login: string | null;
    last_name: string | null;
    password?: string | null;
    phone: string | null;
    profile_color_bg?: string | null;
    profile_color_text?: string | null;
    profile_pic_src?: string | null;
    redeem_pages?: string | null;
    updated_at: string | null;
    user_id: string | number;
    user_status_id?: string | number | null;
  } | null;
  busiess: string | null;
};

export const getUserByEmail = async (
  email?: string,
  config?: Options
): Promise<GetUserByEmailResponse> => {
  const response = await http.get(
    `user/getByEmail/${encodeURIComponent(email ?? "")}`,
    {
      ...config,
    }
  );

  return await response.json<GetUserByEmailResponse>();
};

// PROD-2026-05-21-bug1 — public, JWT-free existence check for the
// post-purchase confirmation card. The protected getUserByEmail
// endpoint above returns 401 for unauthenticated guest customers,
// which silently broke the existing-account variant preflight in
// AccountCreationCard. This lightweight endpoint returns just enough
// for the card to decide which variant to render, with no PII leak.
export type UserExistsResponse = {
  exists: boolean;
  user_id: number | null;
  has_password: boolean;
};

export const userExists = async (
  email?: string,
  config?: Options
): Promise<UserExistsResponse> => {
  const response = await http.get(
    `user/exists/${encodeURIComponent(email ?? "")}`,
    {
      ...config,
    }
  );

  return await response.json<UserExistsResponse>();
};
